import {
  API_AUTH_CERTS,
  API_AUTH_CERTS_FETCH,
  API_AUTH_CERTS_RESET,
  API_AUTH_DUO_ERROR,
  API_AUTH_DUO_FETCH,
  API_AUTH_DUO_SUCCESS,
  API_AUTH_ERROR,
  API_AUTH_FETCH,
  API_AUTH_RESET,
  API_AUTH_SERVER,
  API_AUTH_SET_DUO,
  API_AUTH_SUCCESS,
  API_CAMERAS_ERROR,
  API_CAMERAS_FETCH,
  API_CAMERAS_SUCCESS,
  API_CANCEL_AUTH,
  API_DO_AUTH,
  API_GET_BOOKMARKS_INFO,
  API_GET_DATA,
  API_GET_EVENTS_INFO,
  API_LAYOUTS_ERROR,
  API_LAYOUTS_FETCH,
  API_LAYOUTS_SUCCESS,
  API_MAPS_SUCCESS,
  API_SERVICE_TYPE,
  API_SESSION_TOKEN_IS_OVER,
  API_SET_BOOKMARKS_INFO,
  API_SET_EVENTS_INFO,
  API_SET_GLOBAL_TRIGGERS,
  API_SET_PRIVILLIDGES,
  API_START_HEARTBEATEN,
  API_STOP_HEARTBEATEN,
  API_WEBPAGES_SUCCESS
} from '../../constants/API';
import {
  APICamerasErrorInterface,
  APICamerasFetchInterface,
  APICamerasSuccessInterface,
  APILayoutsErrorInterface,
  APILayoutsFetchInterface,
  APILayoutsSuccessInterface,
  APIMapsSuccessInterface,
  APISetGlobalTriggersAction,
  APISetPrivilegesAction,
  APIWebPagesSuccessInterface,
  AuthCertsActionInterface,
  AuthCertsFetchActionInterface,
  AuthCertsResetActionInterface,
  AuthDuoErrorActionInterface,
  AuthDuoFetchActionInterface,
  AuthDuoSuccessActionInterface,
  AuthErrorActionInterface,
  AuthFetchActionInterface,
  AuthResetActionInterface,
  AuthServerActionInterface,
  AuthSetDuoInterface,
  AuthSuccessActionInterface,
  CancelAuthAction,
  GetAPIDataInterface,
  PrivilegesType,
  RunSetSessionTokenIsOverAction,
  ServiceType,
  ServiceTypeActionInterface,
  SetEventsInfoAction,
  triggerType
} from "./types";

//******cameras *************************************
export const APICamerasFetch = (): APICamerasFetchInterface => ({type: API_CAMERAS_FETCH});
export const APICamerasError = (): APICamerasErrorInterface => ({type: API_CAMERAS_ERROR});
export const APICamerasSuccess = (cameras: any): APICamerasSuccessInterface => ({type: API_CAMERAS_SUCCESS, cameras});

export const APIMapsSuccess = (maps: any): APIMapsSuccessInterface => ({type: API_MAPS_SUCCESS, maps});
export const APIWebPagesSuccess = (webPages: any): APIWebPagesSuccessInterface => ({
  type: API_WEBPAGES_SUCCESS,
  webPages
});

export const getAPIData = (): GetAPIDataInterface => ({type: API_GET_DATA});

//*******layouts*********************************
export const APILayoutsFetch = (): APILayoutsFetchInterface => ({type: API_LAYOUTS_FETCH});
export const APILayoutsError = (): APILayoutsErrorInterface => ({type: API_LAYOUTS_ERROR});
export const APILayoutsSuccess = (layouts: any): APILayoutsSuccessInterface => ({type: API_LAYOUTS_SUCCESS, layouts});

//*******auth ***********************************
export const authFetch = (): AuthFetchActionInterface => ({type: API_AUTH_FETCH});
export const authCertsFetchAction = (): AuthCertsFetchActionInterface => ({type: API_AUTH_CERTS_FETCH});
export const authDuoFetchAction = (): AuthDuoFetchActionInterface => ({type: API_AUTH_DUO_FETCH});
export const authSetDuo = (duoHost: string, sigRequest: string): AuthSetDuoInterface => ({
  type: API_AUTH_SET_DUO,
  duoHost,
  sigRequest
});
export const authDuoSuccess = (sigResponse: string): AuthDuoSuccessActionInterface => ({
  type: API_AUTH_DUO_SUCCESS,
  sigResponse
});
export const authDuoError = (): AuthDuoErrorActionInterface => ({type: API_AUTH_DUO_ERROR});
export const authSuccess = (username: string, token: string, token2?: string): AuthSuccessActionInterface => ({
  type: API_AUTH_SUCCESS,
  username,
  token,
  token2
});
export const authError = (msg: string, title?: string): AuthErrorActionInterface => ({
  type: API_AUTH_ERROR,
  msg,
  title
});
export const authReset = (): AuthResetActionInterface => ({type: API_AUTH_RESET});
export const authCertsReset = (): AuthCertsResetActionInterface => ({type: API_AUTH_CERTS_RESET});
export const authCertsAction = (auth: boolean): AuthCertsActionInterface => ({type: API_AUTH_CERTS, auth});
export const authServerAction = (): AuthServerActionInterface => ({type: API_AUTH_SERVER});
export const setServiceType = (serviceType: ServiceType): ServiceTypeActionInterface => ({
  type: API_SERVICE_TYPE,
  serviceType
});
export const doAuth = (headers: any): any => ({type: API_DO_AUTH, headers});

//*********heartbeaten***********

export const startHeartBeaten = () => ({type: API_START_HEARTBEATEN});
export const stopHeartBeaten = () => ({type: API_STOP_HEARTBEATEN});

//*********bookmarksInfo*********

export const getBookmarksInfo = () => ({type: API_GET_BOOKMARKS_INFO});
export const setBookmarksInfo = (bkmsInfo: any) => ({type: API_SET_BOOKMARKS_INFO, bkmsInfo});


export const runSessionTokenIsOver = (): RunSetSessionTokenIsOverAction => ({type: API_SESSION_TOKEN_IS_OVER});

export const cancelAllRequests = () => ({type: 'cancelAllRequests'});

export const cancelAuth = (): CancelAuthAction => ({type: API_CANCEL_AUTH});

export const getEventsInfo = (confirm?: boolean, alarmID?: string) => ({type: API_GET_EVENTS_INFO, confirm, alarmID});

export const setEventsInfo = (eventsInfo: any): SetEventsInfoAction => ({type: API_SET_EVENTS_INFO, eventsInfo});

export const APISetGlobalTriggers = (globalTriggers: triggerType[]): APISetGlobalTriggersAction => ({
  type: API_SET_GLOBAL_TRIGGERS,
  globalTriggers
});

export const APISetPrivileges = (privileges: PrivilegesType): APISetPrivilegesAction => ({
  type: API_SET_PRIVILLIDGES,
  privileges: privileges
});
